<script setup lang="ts">
import NavigationMenu from "layout/Navigation/NavigationMenu.vue";
</script>

<template>
  <div class="flex w-full">
    <NavigationMenu />
    <router-view />
  </div>
</template>
